const defaultEventTypes = ["birthday", "anniversary", "baby shower", "engagement"];

const makeDate = (offsetDays) => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + offsetDays);
  return date.toISOString().split("T")[0];
};

const buildBookedSlots = (entries) =>
  entries.reduce((accumulator, [offsetDays, lunch, dinner]) => {
    accumulator[makeDate(offsetDays)] = { lunch, dinner };
    return accumulator;
  }, {});

const photoSourceLabel = "Google details normalized locally";

export const banquetCategories = [
  "Near Me",
  "100+ Guests",
  "200+ Guests",
  "Budget Friendly",
  "Premium",
  "Liquor Allowed",
  "Good Parking",
  "Lawn",
  "AC Hall",
];

export const banquetsData = [
  {
    id: "royal-orchid-grand",
    slug: "royal-orchid-grand-mayur-vihar",
    name: "Royal Orchid Grand",
    city: "Delhi",
    locality: "Mayur Vihar Phase 1",
    area: "Mayur Vihar",
    address: "A-27, Mayur Vihar Phase 1 Extension, New Delhi 110091",
    latitude: 28.6044,
    longitude: 77.2951,
    mapUrl: "https://maps.google.com/?q=Royal+Orchid+Grand+Mayur+Vihar+Delhi",
    googlePlaceId: "ChIJRz9b7t3jDDkRk8FfRoyalOrchid",
    googleRating: 4.4,
    googleRatingsTotal: 1287,
    googleSourceLabel: photoSourceLabel,
    googlePhotos: [
      { type: "local", path: "/images/banquet-theme-balloon-decoration-normal--decorzoom.webp", alt: "Royal Orchid Grand facade" },
      { type: "local", path: "/images/banquet-theme-balloon-decoration-whatsapp-image-2025-04-14-at-11.13.19-am-(1)-decorzoom.webp", alt: "Royal Orchid Grand hall" },
      { type: "local", path: "/images/banquet-theme-balloon-decoration-normal2-decorzoom.webp", alt: "Royal Orchid Grand seating" },
    ],
    images: [
      "/images/banquet-theme-balloon-decoration-normal--decorzoom.webp",
      "/images/banquet-theme-balloon-decoration-whatsapp-image-2025-04-14-at-11.13.19-am-(1)-decorzoom.webp",
      "/images/banquet-theme-balloon-decoration-normal2-decorzoom.webp",
    ],
    shortDescription: "AC banquet hall in East Delhi for birthdays, engagements and polished family events.",
    description:
      "Royal Orchid Grand is a polished indoor banquet for East Delhi customers who want dependable service, flexible decor and easy reach from Noida and Central Delhi. The venue works well for milestone birthdays, ring ceremonies, anniversary dinners and premium family gatherings where comfort and guest flow matter.",
    guestMin: 80,
    guestMax: 350,
    vegPrice: 1100,
    nonVegPrice: 1350,
    foodType: "veg-non-veg",
    liquorAllowed: true,
    byobAllowed: false,
    parkingAvailable: true,
    parkingCapacity: 55,
    valetParking: true,
    roomsAvailable: true,
    roomCount: 8,
    bridalRoom: true,
    changingRoom: true,
    venueType: "Banquet Hall",
    indoorOutdoor: ["indoor"],
    acHall: true,
    powerBackup: true,
    lift: true,
    wheelchairFriendly: true,
    decorPolicy: "Outside decor allowed with venue approval.",
    cateringPolicy: "In-house catering preferred. Outside caterers allowed on premium package.",
    djAllowed: true,
    lateNightAllowed: false,
    eventTypes: [...defaultEventTypes, "corporate", "wedding"],
    tags: ["Family Friendly", "Good Parking", "AC Hall", "Wedding Ready"],
    facilities: ["Central AC", "Stage lighting", "Projector support", "Valet desk", "Guest rooms"],
    goodFor: ["Birthday parties with stage setup", "Mid-size wedding functions", "Corporate launches", "Engagement ceremonies"],
    notIdealFor: ["Ultra-budget bookings", "Very small under-50 guest events", "After-midnight baraat-heavy weddings"],
    featured: true,
    availabilityCalendar: {
      bookedSlots: buildBookedSlots([
        [2, true, false],
        [4, true, true],
        [7, false, true],
        [9, true, false],
        [14, true, true],
        [17, false, true],
        [22, true, false],
      ]),
    },
  },
  {
    id: "emerald-courtyard",
    slug: "emerald-courtyard-dwarka",
    name: "Emerald Courtyard",
    city: "Delhi",
    locality: "Sector 12",
    area: "Dwarka",
    address: "Plot 9, Sector 12, Dwarka, New Delhi 110078",
    latitude: 28.5921,
    longitude: 77.046,
    mapUrl: "https://maps.google.com/?q=Emerald+Courtyard+Dwarka+Delhi",
    googlePlaceId: "ChIJ4eW0-9oBDTkR3EmeraldCourt",
    googleRating: 4.3,
    googleRatingsTotal: 964,
    googleSourceLabel: photoSourceLabel,
    googlePhotos: [
      { type: "local", path: "/images/arch-sofa.webp", alt: "Emerald Courtyard lawn" },
      { type: "local", path: "/images/ashishaselfiejpg.webp", alt: "Emerald Courtyard stage area" },
      { type: "local", path: "/images/awesome-decoration.webp", alt: "Emerald Courtyard decor layout" },
    ],
    images: ["/images/arch-sofa.webp", "/images/ashishaselfiejpg.webp", "/images/awesome-decoration.webp"],
    shortDescription: "Banquet plus lawn venue in Dwarka with solid parking and balanced food pricing.",
    description:
      "Emerald Courtyard combines an AC banquet hall with an outdoor lawn, making it practical for Delhi customers who want separate areas for welcome setup, dining and stage decor. The venue is especially useful for mixed-age family events where open space and parking matter.",
    guestMin: 120,
    guestMax: 500,
    vegPrice: 1350,
    nonVegPrice: 1550,
    foodType: "veg-non-veg",
    liquorAllowed: true,
    byobAllowed: true,
    parkingAvailable: true,
    parkingCapacity: 90,
    valetParking: true,
    roomsAvailable: true,
    roomCount: 10,
    bridalRoom: true,
    changingRoom: true,
    venueType: "Banquet + Lawn",
    indoorOutdoor: ["indoor", "lawn", "combo"],
    acHall: true,
    powerBackup: true,
    lift: true,
    wheelchairFriendly: true,
    decorPolicy: "Outside decor allowed. In-house floral upgrades available.",
    cateringPolicy: "In-house catering only.",
    djAllowed: true,
    lateNightAllowed: true,
    eventTypes: ["birthday", "anniversary", "baby shower", "engagement", "wedding", "corporate"],
    tags: ["Premium", "Good Parking", "Liquor Allowed", "Lawn", "Wedding Ready"],
    facilities: ["Separate lawn entry", "Rain backup plan", "Sound permissions support", "Generator backup", "Valet parking"],
    goodFor: ["Sangeet nights", "Wedding receptions", "Corporate dinners", "Large family celebrations"],
    notIdealFor: ["Purely intimate events below 80 guests", "Clients needing outside catering"],
    featured: true,
    availabilityCalendar: {
      bookedSlots: buildBookedSlots([
        [1, false, true],
        [3, true, true],
        [6, true, false],
        [11, false, true],
        [15, true, true],
        [18, true, false],
        [26, false, true],
      ]),
    },
  },
  {
    id: "silver-sage-banquet",
    slug: "silver-sage-banquet-rajouri-garden",
    name: "Silver Sage Banquet",
    city: "Delhi",
    locality: "Rajouri Garden",
    area: "West Delhi",
    address: "J-3/45, Main Ring Road, Rajouri Garden, New Delhi 110027",
    latitude: 28.6425,
    longitude: 77.1209,
    mapUrl: "https://maps.google.com/?q=Silver+Sage+Banquet+Rajouri+Garden+Delhi",
    googlePlaceId: "ChIJw0RajouriSageDTkR0003",
    googleRating: 4.1,
    googleRatingsTotal: 742,
    googleSourceLabel: photoSourceLabel,
    googlePhotos: [
      { type: "local", path: "/images/banner-thumbnail.webp", alt: "Silver Sage entry decor" },
      { type: "local", path: "/images/beautifull-decoration-balloon-curtains-circle.webp", alt: "Silver Sage banquet hall" },
      { type: "local", path: "/images/beautifull-ring.webp", alt: "Silver Sage stage setup" },
    ],
    images: ["/images/banner-thumbnail.webp", "/images/beautifull-decoration-balloon-curtains-circle.webp", "/images/beautifull-ring.webp"],
    shortDescription: "A straightforward West Delhi banquet for birthdays, anniversaries and small weddings.",
    description:
      "Silver Sage Banquet focuses on value and practical event execution. It is a suitable choice when customers want an AC indoor hall in Rajouri Garden with clear package pricing, flexible decor styling and guest comfort without moving into the highest price tier.",
    guestMin: 60,
    guestMax: 220,
    vegPrice: 950,
    nonVegPrice: 1200,
    foodType: "veg-non-veg",
    liquorAllowed: false,
    byobAllowed: false,
    parkingAvailable: true,
    parkingCapacity: 30,
    valetParking: false,
    roomsAvailable: false,
    roomCount: 0,
    bridalRoom: true,
    changingRoom: true,
    venueType: "Banquet Hall",
    indoorOutdoor: ["indoor"],
    acHall: true,
    powerBackup: true,
    lift: true,
    wheelchairFriendly: false,
    decorPolicy: "Outside decor allowed with timing restrictions.",
    cateringPolicy: "In-house catering only.",
    djAllowed: true,
    lateNightAllowed: false,
    eventTypes: [...defaultEventTypes, "wedding"],
    tags: ["Budget Friendly", "Birthday Friendly", "AC Hall", "Family Friendly"],
    facilities: ["LED wall support", "Stage platform", "Two changing rooms", "Power backup"],
    goodFor: ["Birthday celebrations", "Anniversary parties", "Roka ceremonies", "Baby showers"],
    notIdealFor: ["Huge baraat entries", "Need for many guest rooms", "Liquor events"],
    featured: false,
    availabilityCalendar: {
      bookedSlots: buildBookedSlots([
        [2, true, true],
        [5, false, true],
        [8, true, false],
        [13, true, true],
        [19, false, true],
        [24, true, false],
      ]),
    },
  },
  {
    id: "lotus-heritage-hall",
    slug: "lotus-heritage-hall-greater-noida",
    name: "Lotus Heritage Hall",
    city: "Greater Noida",
    locality: "Knowledge Park",
    area: "Knowledge Park II",
    address: "Near Pari Chowk, Knowledge Park II, Greater Noida 201310",
    latitude: 28.4744,
    longitude: 77.503,
    mapUrl: "https://maps.google.com/?q=Lotus+Heritage+Hall+Knowledge+Park+Greater+Noida",
    googlePlaceId: "ChIJLotusHeritageNoida2013",
    googleRating: 4.5,
    googleRatingsTotal: 1503,
    googleSourceLabel: photoSourceLabel,
    googlePhotos: [
      { type: "local", path: "/images/Baby-Shower-Balloon-Setup-Setup-with-Balloons-&-Props-DecorZoom-Event-Decorators-grand.webp", alt: "Lotus Heritage facade" },
      { type: "local", path: "/images/Baby-Shower-Balloon-Setup-Setup-with-Balloons-&-Props-DecorZoom-Event-Decorators-ushape-banquet.webp", alt: "Lotus Heritage banquet hall" },
      { type: "local", path: "/images/Baby-Shower-Balloon-Setup-Setup-with-Balloons-&-Props-DecorZoom-Event-Decorators.webp", alt: "Lotus Heritage dining layout" },
    ],
    images: [
      "/images/Baby-Shower-Balloon-Setup-Setup-with-Balloons-&-Props-DecorZoom-Event-Decorators-grand.webp",
      "/images/Baby-Shower-Balloon-Setup-Setup-with-Balloons-&-Props-DecorZoom-Event-Decorators-ushape-banquet.webp",
      "/images/Baby-Shower-Balloon-Setup-Setup-with-Balloons-&-Props-DecorZoom-Event-Decorators.webp",
    ],
    shortDescription: "Large-format venue near Pari Chowk with indoor hall, lawn and guest rooms for wedding functions.",
    description:
      "Lotus Heritage Hall is built for big-format NCR functions where guest movement, parking and room inventory are important. The combination of hall plus lawn makes it suitable for haldi, engagement, wedding reception and corporate offsite evenings in the same venue ecosystem.",
    guestMin: 150,
    guestMax: 650,
    vegPrice: 1450,
    nonVegPrice: 1750,
    foodType: "veg-non-veg",
    liquorAllowed: true,
    byobAllowed: true,
    parkingAvailable: true,
    parkingCapacity: 130,
    valetParking: true,
    roomsAvailable: true,
    roomCount: 18,
    bridalRoom: true,
    changingRoom: true,
    venueType: "Banquet + Lawn",
    indoorOutdoor: ["indoor", "lawn", "combo"],
    acHall: true,
    powerBackup: true,
    lift: true,
    wheelchairFriendly: true,
    decorPolicy: "Outside decor permitted. Premium in-house styling team available.",
    cateringPolicy: "In-house catering only.",
    djAllowed: true,
    lateNightAllowed: true,
    eventTypes: ["birthday", "engagement", "wedding", "corporate", "anniversary"],
    tags: ["Premium", "300+ Guests", "Lawn", "Good Parking", "Wedding Ready"],
    facilities: ["18 rooms", "Large lawn", "Bridal suite", "Valet", "Generator", "Dedicated service elevators"],
    goodFor: ["Wedding receptions", "Large sangeet events", "Corporate annual meets", "Engagements with 300+ guests"],
    notIdealFor: ["Small low-budget parties", "Events where outside catering is mandatory"],
    featured: true,
    availabilityCalendar: {
      bookedSlots: buildBookedSlots([
        [4, false, true],
        [6, true, true],
        [10, true, false],
        [12, false, true],
        [20, true, true],
        [23, true, false],
        [28, false, true],
      ]),
    },
  },
  {
    id: "ivory-crown-rooftop",
    slug: "ivory-crown-rooftop-gurgaon",
    name: "Ivory Crown Rooftop",
    city: "Gurgaon",
    locality: "Sector 29",
    area: "City Center",
    address: "4th Floor, Leisure Arcade, Sector 29, Gurgaon 122001",
    latitude: 28.4675,
    longitude: 77.0726,
    mapUrl: "https://maps.google.com/?q=Ivory+Crown+Rooftop+Sector+29+Gurgaon",
    googlePlaceId: "ChIJIvoryCrownGGN2026",
    googleRating: 4.2,
    googleRatingsTotal: 618,
    googleSourceLabel: photoSourceLabel,
    googlePhotos: [
      { type: "local", path: "/images/anniversary-surprise-decoration-decorzoom-wgpl.webp", alt: "Ivory Crown rooftop" },
      { type: "local", path: "/images/anniversary-decoration-decorzoom-k3qg.webp", alt: "Ivory Crown lounge setup" },
      { type: "local", path: "/images/anniversary-decor-decorzoom-5lfg.webp", alt: "Ivory Crown dining setup" },
    ],
    images: [
      "/images/anniversary-surprise-decoration-decorzoom-wgpl.webp",
      "/images/anniversary-decoration-decorzoom-k3qg.webp",
      "/images/anniversary-decor-decorzoom-5lfg.webp",
    ],
    shortDescription: "Modern rooftop banquet for cocktails, birthdays and intimate premium functions in Gurgaon.",
    description:
      "Ivory Crown Rooftop is aimed at customers who want skyline energy instead of a standard hall feel. It suits birthdays, pre-wedding functions, anniversaries and corporate social evenings where ambiance and nightlife-friendly location drive the decision.",
    guestMin: 40,
    guestMax: 180,
    vegPrice: 1600,
    nonVegPrice: 1900,
    foodType: "veg-non-veg",
    liquorAllowed: true,
    byobAllowed: false,
    parkingAvailable: true,
    parkingCapacity: 42,
    valetParking: true,
    roomsAvailable: false,
    roomCount: 0,
    bridalRoom: false,
    changingRoom: true,
    venueType: "Rooftop Venue",
    indoorOutdoor: ["rooftop"],
    acHall: false,
    powerBackup: true,
    lift: true,
    wheelchairFriendly: true,
    decorPolicy: "In-house decor only for rooftop safety compliance.",
    cateringPolicy: "In-house catering only.",
    djAllowed: true,
    lateNightAllowed: true,
    eventTypes: ["birthday", "anniversary", "engagement", "corporate"],
    tags: ["Premium", "Liquor Allowed", "Rooftop", "Birthday Friendly"],
    facilities: ["Covered rooftop section", "Cocktail counter", "Sound console", "Lift access"],
    goodFor: ["Cocktail parties", "Surprise birthdays", "Intimate engagement celebrations", "Team parties"],
    notIdealFor: ["Large weddings", "Daytime summer lawn preference", "Customers needing many rooms"],
    featured: false,
    availabilityCalendar: {
      bookedSlots: buildBookedSlots([
        [1, true, false],
        [5, true, true],
        [8, false, true],
        [14, true, false],
        [16, true, true],
        [21, false, true],
        [25, true, false],
      ]),
    },
  },
  {
    id: "sunset-manor-lawn",
    slug: "sunset-manor-lawn-faridabad",
    name: "Sunset Manor Lawn",
    city: "Faridabad",
    locality: "Surajkund Road",
    area: "Green Valley",
    address: "Surajkund Road, Green Valley, Faridabad 121010",
    latitude: 28.4906,
    longitude: 77.2832,
    mapUrl: "https://maps.google.com/?q=Sunset+Manor+Lawn+Faridabad",
    googlePlaceId: "ChIJSunsetManorFaridabad",
    googleRating: 4.0,
    googleRatingsTotal: 554,
    googleSourceLabel: photoSourceLabel,
    googlePhotos: [
      { type: "local", path: "/images/anniversary-decoration-in-ncr-decorzoom-rglt.webp", alt: "Sunset Manor lawn entry" },
      { type: "local", path: "/images/anniversary-decoration-in-ncr-decorzoom-9qvw.webp", alt: "Sunset Manor lawn stage" },
      { type: "local", path: "/images/anniversary-surprise-decoration-decorzoom-479g.webp", alt: "Sunset Manor evening setup" },
    ],
    images: [
      "/images/anniversary-decoration-in-ncr-decorzoom-rglt.webp",
      "/images/anniversary-decoration-in-ncr-decorzoom-9qvw.webp",
      "/images/anniversary-surprise-decoration-decorzoom-479g.webp",
    ],
    shortDescription: "Open lawn venue for weddings and large family events with budget-conscious pricing in Faridabad.",
    description:
      "Sunset Manor Lawn is built for customers who value space, flexible entry decor and larger guest counts over hotel-style interiors. It is especially practical for wedding functions, anniversaries and family events that need parking, stage freedom and late-evening energy.",
    guestMin: 200,
    guestMax: 900,
    vegPrice: 1050,
    nonVegPrice: 1300,
    foodType: "veg-non-veg",
    liquorAllowed: true,
    byobAllowed: true,
    parkingAvailable: true,
    parkingCapacity: 150,
    valetParking: false,
    roomsAvailable: true,
    roomCount: 6,
    bridalRoom: true,
    changingRoom: true,
    venueType: "Lawn",
    indoorOutdoor: ["lawn"],
    acHall: false,
    powerBackup: true,
    lift: false,
    wheelchairFriendly: false,
    decorPolicy: "Outside decor allowed without monopoly fee.",
    cateringPolicy: "Outside catering allowed. In-house packages available.",
    djAllowed: true,
    lateNightAllowed: true,
    eventTypes: ["wedding", "engagement", "anniversary", "corporate"],
    tags: ["Budget Friendly", "300+ Guests", "Lawn", "Liquor Allowed"],
    facilities: ["Open lawn", "Entry gate decor zone", "Generator backup", "Vendor-friendly access"],
    goodFor: ["Big wedding receptions", "Community gatherings", "Large anniversary events", "Corporate family day"],
    notIdealFor: ["Monsoon-sensitive events without backup hall", "Customers needing lift access"],
    featured: false,
    availabilityCalendar: {
      bookedSlots: buildBookedSlots([
        [3, false, true],
        [7, true, true],
        [10, false, true],
        [15, true, false],
        [22, true, true],
        [27, false, true],
        [30, true, false],
      ]),
    },
  },
  {
    id: "pearl-regency-suites",
    slug: "pearl-regency-suites-indirapuram",
    name: "Pearl Regency Suites",
    city: "Ghaziabad",
    locality: "Indirapuram",
    area: "Ahinsa Khand",
    address: "Plot 14, Ahinsa Khand 1, Indirapuram, Ghaziabad 201014",
    latitude: 28.6469,
    longitude: 77.3695,
    mapUrl: "https://maps.google.com/?q=Pearl+Regency+Suites+Indirapuram+Ghaziabad",
    googlePlaceId: "ChIJPearlRegencyGZB001",
    googleRating: 4.3,
    googleRatingsTotal: 881,
    googleSourceLabel: photoSourceLabel,
    googlePhotos: [
      { type: "local", path: "/images/anniversary-decoration-in-delhi-decorzoom-a5q0.webp", alt: "Pearl Regency facade" },
      { type: "local", path: "/images/anniversary-decoration-in-delhi-decorzoom-kpqf.webp", alt: "Pearl Regency hall" },
      { type: "local", path: "/images/anniversary-decor-decorzoom-l8ry.webp", alt: "Pearl Regency table layout" },
    ],
    images: [
      "/images/anniversary-decoration-in-delhi-decorzoom-a5q0.webp",
      "/images/anniversary-decoration-in-delhi-decorzoom-kpqf.webp",
      "/images/anniversary-decor-decorzoom-l8ry.webp",
    ],
    shortDescription: "Hotel-style banquet with rooms in Indirapuram for comfortable family events and guest stay.",
    description:
      "Pearl Regency Suites gives Ghaziabad customers a banquet plus room inventory combination that reduces logistics for outstation guests. It is designed for anniversaries, engagement ceremonies, birthday functions and compact wedding events where comfort and convenience are more important than huge scale.",
    guestMin: 70,
    guestMax: 260,
    vegPrice: 1200,
    nonVegPrice: 1450,
    foodType: "veg-non-veg",
    liquorAllowed: true,
    byobAllowed: false,
    parkingAvailable: true,
    parkingCapacity: 48,
    valetParking: true,
    roomsAvailable: true,
    roomCount: 14,
    bridalRoom: true,
    changingRoom: true,
    venueType: "Hotel Banquet",
    indoorOutdoor: ["indoor"],
    acHall: true,
    powerBackup: true,
    lift: true,
    wheelchairFriendly: true,
    decorPolicy: "Outside decor allowed with vendor registration.",
    cateringPolicy: "In-house catering only.",
    djAllowed: true,
    lateNightAllowed: false,
    eventTypes: ["birthday", "anniversary", "engagement", "baby shower", "wedding", "corporate"],
    tags: ["Family Friendly", "Good Parking", "Premium", "AC Hall"],
    facilities: ["14 guest rooms", "Lift", "Valet", "Bridal suite", "Wheelchair access"],
    goodFor: ["Guest-stay events", "Ring ceremonies", "Birthday lunches", "Compact weddings"],
    notIdealFor: ["Ultra-large events over 300 guests", "Outside catering requirements"],
    featured: true,
    availabilityCalendar: {
      bookedSlots: buildBookedSlots([
        [2, false, true],
        [6, true, true],
        [9, true, false],
        [13, false, true],
        [18, true, true],
        [24, true, false],
      ]),
    },
  },
  {
    id: "marigold-imperial",
    slug: "marigold-imperial-noida-extension",
    name: "Marigold Imperial",
    city: "Noida",
    locality: "Noida Extension",
    area: "Gaur City",
    address: "Near Gaur City Mall, Noida Extension 201318",
    latitude: 28.5874,
    longitude: 77.3905,
    mapUrl: "https://maps.google.com/?q=Marigold+Imperial+Noida+Extension",
    googlePlaceId: "ChIJMarigoldImperialNED",
    googleRating: 4.2,
    googleRatingsTotal: 690,
    googleSourceLabel: photoSourceLabel,
    googlePhotos: [
      { type: "local", path: "/images/barbie-first-birthday-balloon-decoration-for-banquet-main-setup-2.webp", alt: "Marigold Imperial hall" },
      { type: "local", path: "/images/barbie-first-birthday-balloon-decoration-for-banquet-backdrop-view-2.webp", alt: "Marigold Imperial stage" },
      { type: "local", path: "/images/barbie-first-birthday-balloon-decoration-for-banquet-close-view-2.webp", alt: "Marigold Imperial decor close-up" },
    ],
    images: [
      "/images/barbie-first-birthday-balloon-decoration-for-banquet-main-setup-2.webp",
      "/images/barbie-first-birthday-balloon-decoration-for-banquet-backdrop-view-2.webp",
      "/images/barbie-first-birthday-balloon-decoration-for-banquet-close-view-2.webp",
    ],
    shortDescription: "Versatile AC hall for birthdays, baby showers and mid-size family events in Noida Extension.",
    description:
      "Marigold Imperial balances pricing and presentation well for Noida Extension families. The venue is especially effective for first birthdays, baby showers, anniversaries and engagement events where customers want an AC hall, modern decor flexibility and parking that is manageable for a mid-size guest list.",
    guestMin: 50,
    guestMax: 240,
    vegPrice: 1000,
    nonVegPrice: 1250,
    foodType: "veg-non-veg",
    liquorAllowed: false,
    byobAllowed: false,
    parkingAvailable: true,
    parkingCapacity: 36,
    valetParking: false,
    roomsAvailable: true,
    roomCount: 4,
    bridalRoom: true,
    changingRoom: true,
    venueType: "Banquet Hall",
    indoorOutdoor: ["indoor"],
    acHall: true,
    powerBackup: true,
    lift: true,
    wheelchairFriendly: true,
    decorPolicy: "Outside decor allowed.",
    cateringPolicy: "In-house catering only.",
    djAllowed: true,
    lateNightAllowed: false,
    eventTypes: [...defaultEventTypes, "corporate"],
    tags: ["Budget Friendly", "Family Friendly", "Birthday Friendly", "AC Hall"],
    facilities: ["Modern lighting", "Lift access", "Small room block", "Generator"],
    goodFor: ["Birthdays", "Baby showers", "Engagement lunches", "Anniversary dinners"],
    notIdealFor: ["Very large guest counts", "Liquor-focused celebrations"],
    featured: false,
    availabilityCalendar: {
      bookedSlots: buildBookedSlots([
        [1, true, false],
        [4, true, true],
        [8, false, true],
        [12, true, false],
        [17, true, true],
        [20, false, true],
        [26, true, false],
      ]),
    },
  },
  {
    id: "velvet-vista-court",
    slug: "velvet-vista-court-south-delhi",
    name: "Velvet Vista Court",
    city: "Delhi",
    locality: "Chhatarpur",
    area: "South Delhi",
    address: "Main Chhatarpur Road, New Delhi 110074",
    latitude: 28.4937,
    longitude: 77.181,
    mapUrl: "https://maps.google.com/?q=Velvet+Vista+Court+Chhatarpur+Delhi",
    googlePlaceId: "ChIJVelvetVistaSouthD",
    googleRating: 4.6,
    googleRatingsTotal: 1741,
    googleSourceLabel: photoSourceLabel,
    googlePhotos: [
      { type: "local", path: "/images/barbie-first-birthday-balloon-decoration-for-banquet-for-girls-main-setup-2.webp", alt: "Velvet Vista premium hall" },
      { type: "local", path: "/images/barbie-first-birthday-balloon-decoration-for-banquet-for-girls-backdrop-view-2.webp", alt: "Velvet Vista premium stage" },
      { type: "local", path: "/images/barbie-first-birthday-balloon-decoration-for-banquet-for-girls-close-view-2.webp", alt: "Velvet Vista premium decor" },
    ],
    images: [
      "/images/barbie-first-birthday-balloon-decoration-for-banquet-for-girls-main-setup-2.webp",
      "/images/barbie-first-birthday-balloon-decoration-for-banquet-for-girls-backdrop-view-2.webp",
      "/images/barbie-first-birthday-balloon-decoration-for-banquet-for-girls-close-view-2.webp",
    ],
    shortDescription: "High-finish South Delhi banquet for premium wedding events and polished celebrations.",
    description:
      "Velvet Vista Court targets premium event customers who care about finish, guest experience and venue impact. It suits South Delhi wedding functions, upscale engagements, corporate launches and luxury family celebrations where presentation and service quality are priorities.",
    guestMin: 180,
    guestMax: 700,
    vegPrice: 1800,
    nonVegPrice: 2100,
    foodType: "veg-non-veg",
    liquorAllowed: true,
    byobAllowed: false,
    parkingAvailable: true,
    parkingCapacity: 110,
    valetParking: true,
    roomsAvailable: true,
    roomCount: 16,
    bridalRoom: true,
    changingRoom: true,
    venueType: "Luxury Banquet",
    indoorOutdoor: ["indoor", "combo"],
    acHall: true,
    powerBackup: true,
    lift: true,
    wheelchairFriendly: true,
    decorPolicy: "In-house decor only for premium quality control.",
    cateringPolicy: "In-house catering only.",
    djAllowed: true,
    lateNightAllowed: true,
    eventTypes: ["engagement", "wedding", "corporate", "anniversary"],
    tags: ["Premium", "Wedding Ready", "Good Parking", "AC Hall", "300+ Guests"],
    facilities: ["Large pre-function area", "Bridal suite", "Premium valet", "VIP lounge", "Accessible entry"],
    goodFor: ["Luxury weddings", "Premium receptions", "Brand launches", "Large engagement events"],
    notIdealFor: ["Budget-led bookings", "Customers wanting outside decor or catering"],
    featured: true,
    availabilityCalendar: {
      bookedSlots: buildBookedSlots([
        [3, true, false],
        [5, true, true],
        [11, false, true],
        [16, true, false],
        [19, true, true],
        [23, false, true],
        [29, true, false],
      ]),
    },
  },
  {
    id: "harvest-green-pavilion",
    slug: "harvest-green-pavilion-rohini",
    name: "Harvest Green Pavilion",
    city: "Delhi",
    locality: "Rohini Sector 10",
    area: "Rohini",
    address: "Pocket F, Sector 10, Rohini, New Delhi 110085",
    latitude: 28.7213,
    longitude: 77.1238,
    mapUrl: "https://maps.google.com/?q=Harvest+Green+Pavilion+Rohini+Delhi",
    googlePlaceId: "ChIJHarvestGreenRohini",
    googleRating: 4.1,
    googleRatingsTotal: 512,
    googleSourceLabel: photoSourceLabel,
    googlePhotos: [
      { type: "local", path: "/images/Babybox-Decoration-Setup-with-Balloons-&-Props-DecorZoom-Event-Decorators.webp", alt: "Harvest Green pavilion entry" },
      { type: "local", path: "/images/aesthetic-baby-shower-balloon-decoration-for-photo-corner-main-setup-2.webp", alt: "Harvest Green banquet area" },
      { type: "local", path: "/images/aesthetic-welcome-baby-balloon-decoration-for-home-setup-main-setup-2.webp", alt: "Harvest Green decor corner" },
    ],
    images: [
      "/images/Babybox-Decoration-Setup-with-Balloons-&-Props-DecorZoom-Event-Decorators.webp",
      "/images/aesthetic-baby-shower-balloon-decoration-for-photo-corner-main-setup-2.webp",
      "/images/aesthetic-welcome-baby-balloon-decoration-for-home-setup-main-setup-2.webp",
    ],
    shortDescription: "Customer-friendly banquet for small and medium family functions in Rohini.",
    description:
      "Harvest Green Pavilion is a practical neighborhood banquet for Rohini customers who want clean execution, easy pricing and a venue that works well for day functions. It is especially suitable for birthday parties, anniversaries, baby showers and compact engagement events.",
    guestMin: 35,
    guestMax: 160,
    vegPrice: 850,
    nonVegPrice: 0,
    foodType: "veg-only",
    liquorAllowed: false,
    byobAllowed: false,
    parkingAvailable: true,
    parkingCapacity: 22,
    valetParking: false,
    roomsAvailable: false,
    roomCount: 0,
    bridalRoom: false,
    changingRoom: true,
    venueType: "Banquet Hall",
    indoorOutdoor: ["indoor"],
    acHall: true,
    powerBackup: true,
    lift: false,
    wheelchairFriendly: false,
    decorPolicy: "Outside decor allowed.",
    cateringPolicy: "Veg in-house catering only.",
    djAllowed: true,
    lateNightAllowed: false,
    eventTypes: ["birthday", "anniversary", "baby shower", "engagement"],
    tags: ["Budget Friendly", "Family Friendly", "Small Functions", "Veg Only"],
    facilities: ["AC hall", "Stage", "Changing room", "Power backup"],
    goodFor: ["Veg family functions", "Day birthdays", "Baby showers", "Small engagement lunches"],
    notIdealFor: ["Liquor events", "Large weddings", "Need for rooms or valet"],
    featured: false,
    availabilityCalendar: {
      bookedSlots: buildBookedSlots([
        [2, true, false],
        [4, true, true],
        [9, false, true],
        [12, true, false],
        [18, true, true],
        [25, false, true],
      ]),
    },
  },
];

export const banquetCities = [...new Set(banquetsData.map((banquet) => banquet.city))].sort();
export const banquetLocalities = [...new Set(banquetsData.map((banquet) => banquet.locality))].sort();

export const getBanquetBySlug = (slug) => banquetsData.find((banquet) => banquet.slug === slug);
